// Logo brand ESSECI E-LIGHT.
// onDark => wordmark bianco (per fondi scuri); altrimenti wordmark blu (fondi chiari).
// mono   => versione compatta "SE" (sidebar ridotta), senza deformare il wordmark.
export function BrandLogo({ onDark = false, widthClass = "w-40", subtitle, mono = false, className = "" }) {
  if (mono) {
    return (
      <div
        className={`flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 ring-1 ring-white/20 ${className}`}
        data-testid="brand-logo"
      >
        <span className="font-display text-base font-extrabold tracking-tight text-white">SE</span>
      </div>
    );
  }
  const src = onDark ? "/brand-logo-white.png" : "/brand-logo.png";
  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="brand-logo">
      <img src={src} alt="ESSECI E-LIGHT" className={`${widthClass} h-auto object-contain`} />
      {subtitle && (
        <span
          className={`mt-1.5 text-center text-[11px] font-semibold uppercase tracking-[0.22em] ${
            onDark ? "text-white/60" : "text-slate-400"
          }`}
        >
          {subtitle}
        </span>
      )}
    </div>
  );
}
